import { useStudyContext } from '../../../common/context/study/useStudyContext';
import { useCurrentUser } from '../../security/hooks/useCurrentUser';
import { PermissionService } from '../../security/service/PermissionService';
import { PermissionType } from '../../security/type/PermissionType';

export const useInformedConsentIsEnabled = (): boolean => {
  const { study } = useStudyContext();
  const user = useCurrentUser();

  const informedConsentFeatureIsEnabled = !!study.features?.summary.informedConsent.isEnabledOnAnySite;

  const canListStudyIcfs = PermissionService.hasOrgBranchPermission(
    PermissionType.CAN_LIST_STUDY_ICFS,
    user.orgIdsIncludingParents,
  );
  const canListCountryIcfs = PermissionService.hasOrgBranchPermission(
    PermissionType.CAN_LIST_COUNTRY_ICFS,
    user.orgIdsIncludingParents,
  );
  const canListPracticeIcfs = PermissionService.hasOrgBranchPermission(
    PermissionType.CAN_LIST_PRACTICE_ICFS,
    user.orgIdsIncludingParents,
  );

  const canAccessAnyInformedConsentLevel = canListStudyIcfs || canListCountryIcfs || canListPracticeIcfs;
  return informedConsentFeatureIsEnabled && canAccessAnyInformedConsentLevel;
};
